module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-bounce v-bounce1",
    style: (_vm.spinnerBasicStyle)
  }, [_c('div', {
    staticClass: "v-bounce v-bounce2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-bounce v-bounce3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb69d1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-spinner/src/BounceLoader.vue
// module id = 159
// module chunks = 0